import { useState, useCallback } from 'react';
import { getMaxDailyAmountByOrganizationId, updateMaxDailyAmountByPdv } from '../../../../api/saaservices/maxDailyAmount';
import Swal from 'sweetalert2';
import { getSaaId } from '../../../../utils/session.utils';

export const useMaxDailyAmount = (agencySelected, agencies) => {
  const [pdvs, setPdvs] = useState(null);
  const [loading, setLoading] = useState(false);

  const fetchMaxDailyAmount = useCallback(async () => {
    setLoading(true);
    try {
      const response = await getMaxDailyAmountByOrganizationId();
      const pdvsFiltered = pdvsFilteredByAgencieSelected(response, agencySelected);
      const result = mapperPdvsToTable(pdvsFiltered, agencies[0]?.childrenAgencies);
      setPdvs(result);
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "No se pudo obtener listado de puntos de venta.",
      });
    } finally {
      setLoading(false);
    }
  }, [agencySelected, agencies]);

  const updateMaxDailyAmount = useCallback(async (agency) => {
    try {
      const organizationId = getSaaId();
      const response = await updateMaxDailyAmountByPdv(
        organizationId,
        agency.cLogic,
        agency.newAmount ?? 0,
        "abaco"
      );
      
      if (response === "success") {
        Swal.fire({
          icon: "success",
          title: "Éxito",
          text: "El importe máximo diario se actualizó correctamente.",
        });
        await fetchMaxDailyAmount();
        return true;
      }
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "No se pudo actualizar el importe máximo diario.",
      });
      return false;
    }
  }, [fetchMaxDailyAmount]);

  return { pdvs, loading, fetchMaxDailyAmount, updateMaxDailyAmount };
};

// Helper functions
const pdvsFilteredByAgencieSelected = (agencies, agencySelected) => {
  if (!Array.isArray(agencies)) return [];
  return agencies.filter((pdv) => {
    const [pdvNumber] = pdv.puntoDeVenta.split("-");
    return parseInt(pdvNumber) === agencySelected.number;
  });
};

const mapperPdvsToTable = (pdvsMap, childrenAgencies) => {
  return pdvsMap.map((pdv) => {
    const [number, subNumber] = pdv.puntoDeVenta.split("-");
    const agencyName = childrenAgencies?.find(
      (child) =>
        child.number === parseInt(number) &&
        child.subNumber === (subNumber ? parseInt(subNumber) : 0)
    )?.name;
    const cLogicNumber = mapPdvToCLogic(`${pdv.puntoDeVenta}-${String(pdv.maquina)}`);
    return { ...pdv, name: agencyName, cLogicNumber };
  });
};

const mapPdvToCLogic = (input) => {
  const [agent, subag, maqui] = input.split("-");
  const paddedAgent = agent.padStart(2, "0");
  const paddedSubag = subag.padStart(3, "0");
  return parseInt(paddedAgent + paddedSubag + maqui, 10);
};